import { render, staticRenderFns } from "./AddLinkModal.vue?vue&type=template&id=56bb1bad&scoped=true&"
import script from "./AddLinkModal.vue?vue&type=script&lang=js&"
export * from "./AddLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLinkModal.vue?vue&type=style&index=0&id=56bb1bad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb1bad",
  null
  
)

export default component.exports